var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"About"},[_c('h1',[_vm._v("This is an about page")]),_c('p',[_vm._v(_vm._s(_vm.userInfo))]),_c('button',{on:{"click":_vm.backlc}},[_vm._v("返回")]),_c('button',{on:{"click":_vm.backnative}},[_vm._v("原生返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }